/* Copyright (c) 2023 Xperi. All Rights Reserved. */

export class HttpRequestResponse {
    private mUrl: string;

    private mMethod: string;

    private mHeaders: Map<string, string>;

    private mBody: string;

    private mResponseText: string;

    constructor() {
        this.mUrl = '';
        this.mMethod = '';
        this.mHeaders = new Map();
        this.mBody = '';
        this.mResponseText = '';
    }

    public setUrl(url: string): void {
        this.mUrl = url;
    }

    public setMethod(method: string): void {
        this.mMethod = method;
    }

    public setHeaders(header: string, value: string): void {
        this.mHeaders.set(header, value);
    }

    public setBody(body: string): void {
        this.mBody = body;
    }

    public setResponseText(response: string): void {
        this.mResponseText = response;
    }

    public toString(): string {
        const protocol = this.mUrl.split(':')[0] || 'HTTP';
        let sReqResText = `${protocol.toUpperCase()} Request URL: ${this.mUrl}\n`;
        sReqResText += `Request Method: ${this.mMethod}\n`;
        sReqResText += `Request Headers:-\n`;
        this.mHeaders.forEach((value, header) => {
            sReqResText += `${header}: ${value}\n`;
        });
        sReqResText += (this.mBody[0] != null && `\nRequest Body: ${this.mBody}\n`) || '';
        sReqResText += `\nResponse: \n${this.mResponseText}\n`;

        return sReqResText;
    }
}
